import type { SaunaDimensions } from "./types";

/**
 * Default outer footprint per sauna type, in metres.
 *
 * Kept free of Three.js so light surfaces (the landing page's joist plan and
 * type list) can quote the same numbers the engines start from without pulling
 * the 3D bundle. Each engine's `defaultDimensions` points here.
 */
export const SQUARE_DEFAULT_DIMENSIONS: SaunaDimensions = {
	width: 2.5,
	length: 2.0,
};
export const BARREL_DEFAULT_DIMENSIONS: SaunaDimensions = {
	width: 2.0,
	length: 2.5,
};
export const TWO_ROOM_DEFAULT_DIMENSIONS: SaunaDimensions = {
	width: 3.0,
	length: 4.0,
};
